import config from "@/config";
import store from '@/store';
import _ from 'lodash';
export default {
    namespaced: true,
    state: {
      menu: [],
      isFetching: false
    },

    mutations: {
        LOADED_MENU(state, payload) {
            state.isFetching = false;
            state.menu.splice(0, state.menu.length, ...payload);
        },
        LOADING_MENU(state) {
            state.isFetching = true;
        },
    },

    actions: {
        autoLoadMenu({dispatch}){
          dispatch('loadMenu');
        },
        loadMenu({commit}){
          if (config.isBackend) {
            commit('LOADED_MENU', filterItems(_.cloneDeep(PROD_ITEMS)));
          } else {
            commit('LOADED_MENU', DEFAULT_ITEMS);
          }
        }
    },

    getters: {
        MENU_ITEMS: state => state.menu,
    },
  }

  function filterItems(items){
    return items.filter(item => {
      if(store.getters['user/ROLES'].includes('admin')){
        if(Object.keys(item).includes('callback')){
          if(false === item.callback()){
            return false;
          }
        }
        if(Object.keys(item).includes('children')){
            item.children = filterItems(item.children);
        }
        return true;
      }
      if(Array.isArray(item['roles'])){
        if(false === item['roles'].some(role => store.getters['user/ROLES'].includes(role))){
            return false;
        }
      }
      if(Object.keys(item).includes('callback')){
        if(false === item.callback()){
          return false;
        }
      }
      if(Object.keys(item).includes('children')){
        item.children = filterItems(item.children);
      }
      return true;
    });
  }

  const DEFAULT_ITEMS = [
    { title: 'Profile', icon: 'mdi-account-circle', link: '/user/profile' },
    { title: 'Dashboard', icon: 'mdi-home', link: '/dashboard' },
    {
      title: 'E-commerce',
      icon: 'mdi-cart',
      model: false,
      children: [
        { title: 'Product Management', icon: 'mdi-circle-small', link: '/e-commerce/management' },
        { title: 'Product Grid', icon: 'mdi-circle-small', link: '/e-commerce/grid' },
        { title: 'Product Page', icon: 'mdi-circle-small', link: '/e-commerce/detail'}
      ],
    },
    {
      title: 'User',
      icon: 'mdi-account',
      model: false,
      badge: true,
      children: [
        { title: 'User List', icon: 'mdi-circle-small', link: '/user/list'},
        { title: 'User Add', icon: 'mdi-circle-small', link: '/user/add' },
        { title: 'User Edit', icon: 'mdi-circle-small', link: '/user/edit' }
      ],
    },
    { title: 'Documentation', icon: 'mdi-file-document', link: '/documentation'},
    { divider: true },
    { heading: 'TEMPLATE' },
    {
      title: 'Core',
      icon: 'mdi-apps',
      model: false,
      children: [
        { title: 'Typography', icon: 'mdi-circle-small', link: '/core/typography' },
        { title: 'Colors', icon: 'mdi-circle-small', link: '/core/colors' },
        { title: 'Grid', icon: 'mdi-circle-small', link: '/core/grid' },
      ],
    },
    {
      title: 'Tables',
      icon: 'mdi-grid-large',
      model: false,
      children: [
        { title: 'Tables Basic', icon: 'mdi-circle-small', link: '/tables/basic'},
        { title: 'Tables Dynamic', icon: 'mdi-circle-small', link: '/tables/dynamic'}
      ],
    },
    {
      title: 'UI Elements',
      icon: 'mdi-image-filter-none',
      model: false,
      children: [
        { title: 'Icons', icon: 'mdi-circle-small', link: '/ui/icons'},
        { title: 'Badges', icon: 'mdi-circle-small', link: '/ui/badges'},
        { title: 'Carousel', icon: 'mdi-circle-small', link: '/ui/carousel'},
        { title: 'Cards', icon: 'mdi-circle-small', link: '/ui/cards'},
        { title: 'Modal', icon: 'mdi-circle-small', link: '/ui/modal'},
        { title: 'Notifications', icon: 'mdi-circle-small', link: '/ui/notifications'},
        { title: 'Navbar', icon: 'mdi-circle-small', link: '/ui/navbar'},
        { title: 'Tooltips', icon: 'mdi-circle-small', link: '/ui/tooltips'},
        { title: 'Tabs', icon: 'mdi-circle-small', link: '/ui/tabs'},
        { title: 'Pagination', icon: 'mdi-circle-small', link: '/ui/pagination'},
        { title: 'Progress', icon: 'mdi-circle-small', link: '/ui/progress'},
      ],
    },
    {
      title: 'Forms',
      icon: 'mdi-file-document',
      model: false,
      children: [
        { title: 'Form Elements', icon: 'mdi-circle-small', link: '/forms/elements' },
        { title: 'Form Validation', icon: 'mdi-circle-small', link: '/forms/validation'},
      ],
    },
    {
      title: 'Charts',
      icon: 'mdi-chart-bar',
      model: false,
      children: [
        { title: 'Charts Overview', icon: 'mdi-circle-small', link: '/charts/overview'},
        { title: 'Line Charts', icon: 'mdi-circle-small', link: '/charts/line-charts'},
        { title: 'Bar Charts', icon: 'mdi-circle-small', link: '/charts/bar-charts'},
        { title: 'Pie Charts', icon: 'mdi-circle-small', link: '/charts/pie-charts'},
      ],
    },
    {
      title: 'Maps',
      icon: 'mdi-map',
      model: false,
      children: [
        { title: 'Google Maps', icon: 'mdi-circle-small', link: '/maps/google' },
        { title: 'Vector Maps', icon: 'mdi-circle-small', link: '/maps/vector' },
      ],
    },
    {
      title: 'Extra',
      icon: 'mdi-star',
      model: false,
      children: [
        { title: 'Calendar', icon: 'mdi-circle-small', link: '/extra/calendar' },
        { title: 'Invoice', icon: 'mdi-circle-small', link: '/extra/invoice' },
        { title: 'Login Page', icon: 'mdi-circle-small', link: '#', action: () => this.logOut() },
        { title: 'Error Page', icon: 'mdi-circle-small', link: '/extra/error'},
        { title: 'Gallery', icon: 'mdi-circle-small', link: '/extra/gallery'},
        { title: 'Search Result', icon: 'mdi-circle-small', link: '/extra/search-result'},
        { title: 'Time Line', icon: 'mdi-circle-small', link: '/extra/timeLine'},
      ],
    },
    {
      title: 'Menu Levels',
      icon: 'mdi-folder',
      model: false,
      children: [
        { title: 'Level 1.1', icon: 'mdi-circle-small', },
        {
          title: 'Level 1.2',
          icon: 'mdi-folder',
          model: false,
          children: [
            { title: 'Calendar', icon: 'mdi-circle-small', link: '/extra/calendar'},
            { title: 'Invoice', icon: 'mdi-circle-small', link: '/extra/invoice'},
          ],
        },
      ],
    },
    { divider: true },
    { heading: 'HELP' },
    { title: 'Library', icon: 'mdi-book-variant-multiple'},
    { title: 'Support', icon: 'mdi-forum'},
    { title: 'FAQ', icon: 'mdi-help-circle-outline', },
    { divider: true },
    { heading: 'PROJECTS' },
    { title: 'My recent', icon: 'mdi-circle-medium', color: 'warning'},
    { title: 'Starred', icon: 'mdi-circle-medium', color: 'primaryConst'},
    { title: 'Background', icon: 'mdi-circle-medium', color: 'error'},
    { divider: true },
    { title: 'Add section', icon: 'mdi-plus-circle', color: 'secondary', size: 36, action: () => this.addSection()},
    { divider: true },
  ];

  const PROD_ITEMS = [
    // { title: 'Профиль', icon: 'mdi-account-circle', link: '/user/profile' },
    { title: 'Главная', icon: 'mdi-monitor-dashboard', link: '/main' },
    { title: 'Сотрудники', icon: 'mdi-account-multiple', link: '/work-space' },
    { title: 'Мои объекты', icon: 'mdi-home-city', link: '/organizations/houses'},
    { title: 'Мои организации', icon: 'mdi-briefcase-search', link: '/organizations/index'},
    // {
    //   title: 'Организации',
    //   icon: 'mdi-briefcase-search',
    //   model: false,
    //   badge: false,
    //   children: [
    //     { title: 'Мои организации', icon: 'mdi-ticket-account', link: '/organizations/index' },
    //     { title: 'Добавление', icon: 'mdi-plus-box-outline', link: '/organizations/add' },
    //   ],
    // },
    // {
    //   title: 'Пользователи',
    //   icon: 'mdi-account-supervisor-circle',
    //   model: false,
    //   badge: false,
    //   roles: ['admin'],
    //   children: [
    //     { title: 'Список', icon: 'mdi-circle-small', link: '/admin/user/list'},
    //     { title: 'Добавить', icon: 'mdi-circle-small', link: '/admin/user/add' },
    //     { title: 'Редактировать', icon: 'mdi-circle-small', link: '/admin/user/edit' }
    //   ],
    // },
    {
      title: 'ГИС ЖКХ',
      icon: 'mdi-city',
      model: false,
      badge: false,
      children: [
        {
          title: 'Соцзащита',
          icon: 'mdi-city',
          model: false,
          badge: false,
          callback: () => store.getters['workspace/ORGANIZATION_DEBT_RESULTS_STATUS'] === 'CONNECT',
          children: [
            { title: 'Запросы', icon: 'mdi-circle-small', link: '/social/requests'},
            { title: 'Должники', icon: 'mdi-circle-small', link: '/social/person-debtors',},
          ],
        },
        {
          title: 'Соцзащита',
          icon: 'mdi-city',
          model: false,
          badge: false,
          callback: () => store.getters['workspace/ORGANIZATION_DEBT_RESULTS_STATUS'] !== 'CONNECT',
          link: '/social/requests'
        },
        { title: 'Сопровождение', icon: 'mdi-circle-small', link: '/maintenance',},
      ],
    },

    {
      title: 'Контрагенты',
      icon: 'mdi-city',
      model: false,
      badge: false,
      callback: () => store.getters['user/IS_ADMIN'],
      children: [
        { title: 'Юр лица', icon: 'mdi-circle-small', link: '/contr-agents'},
        { title: 'Контакты', icon: 'mdi-circle-small', link: '/contr-agents/contacts' },
      ],
    },
    {
      title: 'Админ',
      icon: 'mdi-city',
      model: false,
      badge: false,
      roles: ['admin'],
      callback: () => store.getters['user/IS_ADMIN'],
      children: [
        {
          title: 'Пространства',
          icon: 'mdi-city',
          model: false,
          badge: false,
          roles: ['admin'],
          link: '/admin/workspaces'
        },
        {
          title: 'Ошибки соцзащиты',
          icon: 'mdi-city',
          model: false,
          badge: false,
          roles: ['admin'],
          link: '/admin/errors/import-debt-responses'
        },
        {
          title: 'Метрики',
          icon: 'mdi-city',
          model: false,
          badge: false,
          roles: ['admin'],
          link: '/admin/export-request-statistic'
        },
      ],
    },
    {
      title: 'Подписки',
      icon: 'mdi-account',
      model: false,
      badge: false,
      roles: ['admin'],
      children: [
        { title: 'Мои подписки', icon: 'mdi-circle-small', link: '/subscriptions'},
        { title: 'Мои счета', icon: 'mdi-circle-small', link: '/subscriptions/invoices'},
        { title: 'Баланс', icon: 'mdi-circle-small', link: '/subscriptions/balance'},
      ],
    },
    {
      title: 'Обращения',
      icon: 'mdi-account',
      model: false,
      badge: false,
      children: [
        { title: 'Список', icon: 'mdi-circle-small', link: '/appeals'},
      ],
    },
  ];